module.exports = __webpack_public_path__ + "img/ventilation-fan-blower-icon.a773527c.svg";